<!-- /* [MATCH-NAP-C-POP] 나의 매칭현황 - 보낸 자문서 보기(기업) */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="보낸 NAP 자문서 보기"
      disabledFooter
    >
      <div class="popupViewProfile">
        <div class="popupViewProfileCardImage">
          <figure class="networkSearchItemImage">
            <img src="/images/manager/matching/demo1.png" alt="미국 국기" />
          </figure>
          <div class="popupViewProfileCardImageText">
            <h3
              style="color: #294A7A; font-size: 17px; font-weight: 400; margin-bottom: 4px;"
            >
              보낸 기업
            </h3>
            <h3 class="popupViewProfileCardImageTitle">
              (주)행복을 만드는 사람들
            </h3>
            <h5 class="popupViewProfileCardImageDesc">032-222-3333</h5>
            <h5 class="popupViewProfileCardImageEmail">asdfsadf@naver.com</h5>
            <MainButton
              btnText="홈페이지"
              customFontSize="16px"
              width="116px"
              customHeight="32px"
            />
          </div>
        </div>

        <h6
          class="popupViewProfileHeadline"
          style="padding-bottom: 0px !important;"
        >
          매칭 프로세스
        </h6>
        <section class="flex statusMatchingRow">
          <div
            class="statusMatchingItem"
            v-for="(item, index) in statusMatchingItems"
            :key="index"
            :style="{ backgroundColor: item.bgColor }"
          >
            <figure class="image">
              <img :src="item.img" :alt="item.title" />
            </figure>
            <div class="itemText">
              <div style="display: flex; justify-content: center;">
                <div class="itemTextIcon">
                  <figure>
                    <img :src="item.icon" :alt="item.title" />
                  </figure>
                  <h6>{{ item.title }}</h6>
                </div>
              </div>
              <h6 class="itemTextDesc">
                {{ item.desc }}
              </h6>
            </div>
          </div>
        </section>

        <section>
          <ValidationObserver v-slot="{ handleSubmit }" class="aRow5">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
            >
              <div style="margin-bottom: 50px;">
                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">신청서</h3>
                <ValidationProvider
                  name="신청 대상 기업"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="신청 대상 기업"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="매칭신청 사유"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="매칭신청 사유"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">연락처 정보</h3>
                <ValidationProvider
                  name="신청자 이름"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="신청자 이름"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="이메일 주소"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="이메일 주소"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="전화번호"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="전화번호"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">NAP 자문 요청</h3>
                <ValidationProvider
                  name="NAP 자문 요청 사항"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="NAP 자문 요청 사항"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
              </div>

              <div class="modal-action">
                <MainButton btnText="확인" />
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import InputField from "@/components/formControl/InputField.vue";

export default {
  name: "MatchNapCPopup",
  components: {
    BasicModal,
    MainButton,
    ValidationObserver,
    ValidationProvider,
    TextAreaInputField,
    InputField,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
  },
  data() {
    return {
      form: {},
      statusMatchingItems: [
        {
          id: 1,
          title: "프로필 작성",
          desc: "다른 기업들에게 보여질 소중한 기업정보를 입력해주세요.",
          img: "/images/myPage/matching1.svg",
          icon: "/images/myPage/docs.svg",
          bgColor: "#FFFDEE",
          textColor: "#26336A",
        },
        {
          id: 1,
          title: "네트워킹 검색",
          desc: "다양한 시니어산업 기업 또는 관심 기업들을 찾아보세요.",
          img: "/images/myPage/matching2.svg",
          icon: "/images/myPage/search.svg",
          bgColor: "#FFFCDF",
          textColor: "#3F7416",
        },
        {
          id: 1,
          title: "네트워킹 매칭",
          desc: "직접 매칭 혹은 AgeTech Platform 자문을 통해 기업 매칭 진행.",
          img: "/images/myPage/matching3.svg",
          icon: "/images/myPage/chat.svg",
          textColor: "#2B939A",
          bgColor: "#FFFACD",
        },
        {
          id: 1,
          title: "네트워킹 진행",
          desc:
            "매칭이 이루어졌다면 상대 기업과 비즈니스 네트워킹을 해보세요.{}",
          img: "/images/myPage/matching4.svg",
          icon: "/images/myPage/hand.svg",
          textColor: "#BD4444",
          bgColor: "#FFF499",
        },
      ],
    };
  },
  methods: {
    onClickSubmitForm() {},
  },
};
</script>

<style lang="scss" scoped></style>
